import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, Activity, Clock } from 'lucide-react';
import { slideUp, staggerContainer } from '../utils/animations';
const metrics = [{
  label: 'Trademarks Protected',
  value: '3,000+',
  icon: ShieldCheck
}, {
  label: 'Infringements Detected',
  value: '30,000+',
  icon: Activity
}, {
  label: 'Average Response Time',
  value: '<1hr',
  icon: Clock
}];
const testimonials = [{
  quote: "Watchdog's automated evidence collection saved our legal team hundreds of hours. It's essential for IP enforcement.",
  author: 'Elena Rodriguez',
  role: 'General Counsel, TechFlow',
  avatar: 'ER'
}, {
  quote: 'The ability to instantly detect counterfeit listings across global marketplaces has been a game changer for our brand protection.',
  author: 'Marcus Chen',
  role: 'IP Manager, GrowthScale',
  avatar: 'MC'
}];
export function TrustSection() {
  return <section className="py-20 md:py-28 lg:py-32 bg-white border-b border-slate-100" data-id="element-349">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-350">
        {/* Metrics Grid */}
        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16 md:mb-20" data-id="element-351">
          {metrics.map((metric, i) => <motion.div key={metric.label} variants={slideUp} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} className="bg-slate-50 rounded-2xl p-8 text-center hover:bg-indigo-50 transition-colors duration-300 border border-slate-100 cursor-default" data-id="element-352">
              <motion.div initial={{
            scale: 0
          }} whileInView={{
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1 + 0.3,
            type: 'spring',
            stiffness: 200
          }} className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm text-indigo-600" data-id="element-353">
                <metric.icon className="w-6 h-6" data-id="element-354" />
              </motion.div>
              <motion.div initial={{
            opacity: 0,
            scale: 0.5
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1 + 0.5
          }} className="text-4xl font-bold text-slate-900 mb-2" data-id="element-355">
                {metric.value}
              </motion.div>
              <div className="text-slate-600 font-medium" data-id="element-356">{metric.label}</div>
            </motion.div>)}
        </motion.div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-357">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} whileHover={{
          y: -5,
          transition: {
            duration: 0.2
          }
        }} className="bg-white border border-slate-100 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300" data-id="element-358">
              <div className="flex gap-1 mb-4" data-id="element-359">
                {[1, 2, 3, 4, 5].map(s => <motion.div key={s} initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.2 + s * 0.05
            }} data-id="element-360">
                    <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-361" />
                  </motion.div>)}
              </div>
              <p className="text-lg text-slate-800 mb-6 leading-relaxed" data-id="element-362">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-363">
                <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center font-bold text-slate-600" data-id="element-364">
                  {t.avatar}
                </div>
                <div data-id="element-365">
                  <div className="font-bold text-slate-900" data-id="element-366">{t.author}</div>
                  <div className="text-sm text-slate-500" data-id="element-367">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}